<template>
  <div class="noticedetails" v-loading="loading">
    <div class="inner">
      <!-- 面包屑 -->
      <div class="notdeta_mbs">
        <div class="not_cents">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item to="/notice" class="breadnme">
              <span>行业动态</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ noticeTitle }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- 内容 -->
      <div class="notdeta_cont">
        <!-- 标题 -->
        <div class="not_titles">
          <p>{{ noticeTitle }}</p>
        </div>
        <p class="time_po">发布时间: {{ time }}</p>
        <div class="con_all">
          <div v-html="noticeContent" class="ql-editor"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nocget } from "@/api/notice.js";
export default {
  name: "noticedetails",
  data() {
    return {
      time: "",
      noticeTitle: "",
      noticeContent: "",
      title: "",
      loading: false,
    };
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", 1020);
  },
  mounted() {
    let { title, id } = this.$route.params;
    this.title = title;
    if (title == 1 || title == 2) {
      this.nocget({
        noticeType: title,
        noticeId: id,
      });
    }
  },
  methods: {
    nocget(params) {
      this.loading = true;
      nocget(params)
        .then((res) => {
          this.loading = false;
          const data = res.rows[0];
          this.time = data.createTime;
          this.noticeTitle = data.noticeTitle;
          this.noticeContent = data.noticeContent
            .replace(/\/prod-api/g, process.env.VUE_APP_BASE_API)
            .replace(/\<img/g, "<img style='margin:10px auto;'");
        })
        .catch(() => [(this.loading = false)]);
    },
  },
};
</script>
<style lang="scss" scoped>
.noticedetails {
  width: 100%;
  min-height: 600px;
  background-color: #eeeeee;
  overflow: hidden;
  padding: 30px 0 80px;
  .notdeta_mbs {
    width: 100%;
    height: 50px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    .not_cents {
      margin: 20px 0 0 40px;
      .breadnme {
        span {
          &:hover {
            color: #1d4434 !important;
          }
        }
      }
    }
  }
  // 内容
  .notdeta_cont {
    width: 100%;
    min-height: 600px;
    background: #ffffff;
    box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: 30px;
    padding: 50px;
    .not_titles {
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      color: #182837;
    }
    .time_po {
      width: 100%;
      margin: 20px auto;
      font-size: 16px;
      font-weight: 500;
      color: #182837;
    }
    // .con_all {
    //   font-size: 16px;
    //   font-weight: 500;
    //   color: #333333;
    //   margin-top: 30px;
    //   line-height: 1.7;
    //   text-indent: 20px;
    // }
  }
}
</style>
